import { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Col, Row } from "react-bootstrap";
import { getPopularSoftSolList } from "api/CategoryService";
import { Link } from "react-router-dom";
const menuPayload = [
  {
    category: "Project & Task Management",
    items: [
      "Task Assignment",
      "Project Timelines",
      "Time Tracking"
    ]
  },
  {
    category: "Team Management",
    items: [] // No items shown, assume empty or collapsed
  },
  {
    category: "Views",
    items: [] // No items shown
  },
  {
    category: "Automation",
    items: [
      "Workflow Automation",
      "Prebuilt Automation Recipes",
      "Custom Automation"
    ]
  },
  
  {
    category: "Templates",
    items: [] // No items shown
  },
  {
    category: "Collaboration Tools", // Appears again at the bottom (likely duplicate)
    items: [] // No items shown
  },
  {
    category: "Collaboration Tools",
    items: [
      "Comments and Mentions",
      "File Sharing",
      "Updates Section"
    ]
  },
 
  {
    category: "Reporting and Analytics",
    items: [] // No items shown
  },

];
const AccordionComponent = ({features}) => {

 
  // const chunkArray = (array, chunkSize) => {
  //   const chunks = [];
  //   for (let i = 0; i < array.length; i += chunkSize) {
  //     chunks.push(array.slice(i, i + chunkSize));
  //   }
  //   return chunks;
  // };
  
  // const columns = chunkArray(features, 3); // 3 categories per column
 console.log('features', features)
return <Row className="g-3">
  {features?.map((category, idx) => (
    <Col sm={6} lg={4} key={idx}>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="mb-3">
          <Accordion.Header className="bg-light">
            <span className="fw-bold">{category?.title}</span>
          </Accordion.Header>
          <Accordion.Body className="p-3">
            {category?.descriptions?.length > 0 ? (
              category.descriptions.map((item, i) => (
                <div key={i} className="mb-2 product-item">
                  <span className="text-muted small">• {item?.value}</span>
                </div>
              ))
            ) : (
              <div className="text-muted">No items available</div>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Col>
  ))}
</Row>


};

export default AccordionComponent;
